<template>
  <div class="charge-warp" v-loading="loading">
    <div class="display-f just-b align-i-c">
      <el-form ref="form" :model="searchForm" inline>
        <el-form-item>
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="searchForm.date" type="datetimerange"
            :default-time="['00:00:00', '23:59:59']" :picker-options="pickerOptions" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" align="right">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.originalDeptId" placeholder="收费医馆" clearable>
            <el-option v-for="item in deptList" :key="item.deptId" :label="item.deptName" :value="item.deptId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.recipeType" placeholder="配方单类型" clearable>
            <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.status" placeholder="配方单状态" clearable>
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.payStatus" placeholder="退款状态" clearable>
            <el-option v-for="item in refundStatusList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <custom-button type="primary" @click="handleSearch">查询</custom-button>
          <custom-button type="" @click="handleReset">重置</custom-button>
        </el-form-item>
      </el-form>
      <custom-button type="primary" plain @click="handleExport">导出</custom-button>

    </div>
    <div class="table-warp">
      <customTable :cell-style="{ borderColor: '#DDDDDD' }" height="600" tooltip-effect="dark"
        :currentPageSize="searchForm.pageSize" @pageChange="pageChange" :currentPage="searchForm.pageNum" :total="total"
        :tableData="tableData" :column="column" :header-cell-style="{ background: '#F0F1F3', borderColor: '#DDDDDD' }"
        border>
      </customTable>
    </div>
  </div>
</template>

<script>
import customTable from '@/components/customTable/customTable'
import { statementDTO, CommonDTO, deptDTO } from '@/DTO/index'
import { Utils } from '@/utils/utils'
import moment from 'moment';
import { isMoreThanOneYear, isNull, debounce, dictText,isWithinTimeRange } from '@/utils/validateBase'
export default {
  // 定义引入的组件
  components: { customTable },
  props: {},
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '今日',
          onClick(picker) {
            const end = Utils.timeFormat(Number(Utils.endOfDay(moment())), 'yyyy-MM-DD HH:mm:ss')
            const start = Utils.timeFormat(Number(Utils.startOfDay(moment())), 'yyyy-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '昨日',
          onClick(picker) {
            let yesterday = moment().subtract(1, 'days')
            const end = Utils.timeFormat(Number(Utils.endOfDay(yesterday)), 'yyyy-MM-DD HH:mm:ss')
            const start = Utils.timeFormat(Number(Utils.startOfDay(yesterday)), 'yyyy-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '本周',
          onClick(picker) {
            const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('isoWeek'))), 'yyyy-MM-DD HH:mm:ss')
            const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('isoWeek'))), 'yyyy-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end]);
          }
        },
        {
          text: '本月',
          onClick(picker) {
            const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('month'))), 'yyyy-MM-DD HH:mm:ss')
            const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('month'))), 'yyyy-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end]);
          }
        },
        {
          text: '本年',
          onClick(picker) {
            const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('year'))), 'yyyy-MM-DD HH:mm:ss')
            const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('year'))), 'yyyy-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end]);
          }
        },
        ]
      },
      searchForm: {
        date: [],
        recipeType: '',
        status: '',
        originalDeptId: '',
        payStatus: '',
        pageNum: 1,
        pageSize: 20,
      },//搜索条件
      tableData: [],//表格数据
      total: 0,//总数
      deptList: [],//医馆列表
      column: [
        { label: "收费完成时间", prop: "tollTime", align: 'left', width: 180, },
        { label: "处理时间", prop: "handlingTime", align: 'left', width: 180, },
        { label: "收费员", prop: "tollName", align: 'left', width: 100,showOverflowTooltip:true },
        { label: "收费医馆", prop: "tollDeptName", align: 'left', width: 100},
        { label: "处理医馆", prop: "transferDeptName", align: 'left', width: 100 },
        { label: "是否医保支付", prop: "ybPayStatus", align: 'left', width: 120,formatter:(row)=>{ return row.ybPayStatus === 1 ? '是' : '否' } },
        { label: "接待人", prop: "createBy", align: 'left',width: 100 },
        { label: "患者姓名", prop: "patientName", align: 'left', width: 100 },
        { label: "患者电话", prop: "phone", align: 'left', width: 120 },
        { label: "配方单类型", prop: "recipeType", align: 'left', width: 100,formatter:(row)=>{ return dictText(row.recipeType, this.typeList) } },
        { label: "加工方式", prop: "handlingWay", align: 'left', width: 100 },
        { label: "加工费", prop: "handlingAmount", align: 'center', width: 80 },
        { label: "加工费是否退款", prop: "processStatus", align: 'left', width: 120,formatter:(row)=>{ return row.processStatus === 1 ? '是' : '否' }  },
        { label: "配方单剂量（总量）", prop: "dosage", align: 'left',width: 150 },
        { label: "配方单剂量（退款）", prop: "dosageRefund", align: 'left',width: 150 },
        { label: "单剂味数", prop: "drugNumber", align: 'left',width: 80 },
        { label: "配方单药品金额（实收）", prop: "detailedDrugAmount", align: 'left', width: 180 },
        { label: "配方单药品金额（退款）", prop: "detailedDrugRefundAmount", align: 'left', width: 180 },
        { label: "配送地址", prop: "detailedAddress", align: 'left',width: 180,showOverflowTooltip:true, },
        { label: "配送费是否退款", prop: "deliveryWayStatus", align: 'left',width: 120, formatter:(row)=>{ return row.deliveryWayStatus === 1 ? '是' : '否' } },
        { label: "收方时间", prop: "consigneeNameTime", align: 'left',width: 180, },
        { label: "收方人", prop: "consigneeName", align: 'left',width: 100,  },
        { label: "开始配方扫码人", prop: "startCodeScanner", align: 'left',width: 120,  },
        { label: "开始配方时间", prop: "startCodeScanTime", align: 'left' ,width: 180,},
        { label: "结束配方扫码人", prop: "endCodeScanner", align: 'left' ,width: 120,},
        { label: "结束配方时间", prop: "endCodeScanTime", align: 'left',width: 180 },
        { label: "复核配方扫码人", prop: "endReviewCodeScan", align: 'left',width: 120 },
        { label: "复核通过时间", prop: "endReviewCodeScanTime", align: 'left',width: 180 },
        { label: "开始加工扫码人", prop: "startProcessingCodeScanner", align: 'left',width: 120 },
        { label: "开始加工时间", prop: "startProcessingCodeScannerTime", align: 'left',width: 180 },
        { label: "结束加工扫码人", prop: "endProcessingCodeScanner", align: 'left',width: 120 },
        { label: "结束加工时间", prop: "endProcessingCodeScannerTime", align: 'left',width: 180 },
        { label: "运单号", prop: "trackingNumber", align: 'left',width: 200,showOverflowTooltip:true },
        { label: "配方单状态", prop: "status", align: 'left' ,width: 100,formatter:(row)=>{ return dictText(row.status, this.statusList) }},
        { label: "退款状态", prop: "payRefundAStatus", align: 'left',width: 80,formatter:(row)=>{ return dictText(row.payRefundAStatus, this.refundStatusList) } },
        { label: "备注", prop: "remark", align: 'left', width: 100,showOverflowTooltip:true },
      ],//表头
      statusList: [
        { value: '0', label: '待发送' },
        { value: '1', label: '待收方' },
        { value: '2', label: '待配方' },
        { value: '3', label: '配方中' },
        { value: '4', label: '待复核' },
        { value: '5', label: '待加工' },
        { value: '6', label: '加工中' },
        { value: '7', label: '待打包' },
        { value: '8', label: '待配送' },
        { value: '9', label: '配送中' },
        { value: '10', label: '待提货' },
        { value: '11', label: '已完成' },
        { value: '12', label: '已退费' },
      ],
      refundStatusList:[
        { value: 1, label: '未退款' },
        { value: 2, label: '部分退款' },
        { value: 3, label: '已退款' },
      ],
      typeList: [
        { value: '0', label: '非处方项目' },
        { value: '1', label: '中药处方' },
        { value: '4', label: '中成药处方' },
        { value: '5', label: '医联产品' },
      ],
      loading:false
    }
  },
  //变量监听
  watch: {},
  // 页面初始化
  created() {
    let time = CommonDTO.getSystemTimeDTO()
    let startOfDay = Number(Utils.startOfDay(this.$moment(time)))
    let endOfDay = Number(Utils.endOfDay(this.$moment(time)))
    this.searchForm.date[0] = Utils.timeFormat(startOfDay, 'yyyy-MM-DD HH:mm:ss')
    this.searchForm.date[1] = Utils.timeFormat(endOfDay, 'yyyy-MM-DD HH:mm:ss')
    this.getFormulaLog()
    this.getDeptList()
  },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {
    //获取所有医馆
    async getDeptList() {
      this.deptList = await deptDTO.getDeptList()

    },
    /**
     * 页码改变
     */
    pageChange(obj) {
      let { current, size } = obj
      this.searchForm.pageNum = current
      this.searchForm.pageSize = size
      this.getFormulaLog()
    },
    /**
     * 重置
     */
    handleReset() {
      this.searchForm = {
        date: [],
        recipeType: '',
        status: '',
        originalDeptId: '',
        payStatus: '',
        pageNum: 1,
        pageSize: 20,
      }
      let time = CommonDTO.getSystemTimeDTO()
      let startOfDay = Number(Utils.startOfDay(this.$moment(time)))
      let endOfDay = Number(Utils.endOfDay(this.$moment(time)))
      this.searchForm.date[0] = Utils.timeFormat(startOfDay, 'yyyy-MM-DD HH:mm:ss')
      this.searchForm.date[1] = Utils.timeFormat(endOfDay, 'yyyy-MM-DD HH:mm:ss')
      this.getFormulaLog()
    },

    /**
     * 搜索
     */
    handleSearch() {
      this.searchForm.pageNum = 1
      let flag = isMoreThanOneYear(this.searchForm.date[0], this.searchForm.date[1], 366)
      if (flag) return this.$message.error('时间范围不能超过一年')
      // let HH = this.$moment().get('hour')
      // let flagOneDay = isMoreThanOneYear(this.searchForm.date[0], this.searchForm.date[1], 1)
      // if(flagOneDay && HH < 22 && HH > 7 ) return this.$message.error('当前选择的日期范围大于1天，请22:00后查询')
      this.getFormulaLog()
    },

    /**
     * 查询配方日志
     */
    async getFormulaLog() {
      // if(isWithinTimeRange(9, 0, 18, 0)){
      //   this.$message.warning('由于服务器压力过大，请勿在9:00-18:00之间使用此功能，带来不便，敬请谅解')
      //   return;
      // } 
      this.loading=true
      this.searchForm.startPayTime = this.searchForm.date[0]
      this.searchForm.endPayTime = this.searchForm.date[1]
      let { code, data } = await statementDTO.getFormulaLog(this.searchForm)
      if (code == 200) {
        this.loading=false
        this.tableData = data.records
        this.total = data.total
      }else{
        this.loading=false
      }
    },

    /**
    * 导出
    */
    handleExport: debounce(function () {
      // if(isWithinTimeRange(9, 0, 18, 0)){
      //   this.$message.warning('由于服务器压力过大，请勿在9:00-18:00之间使用此功能，带来不便，敬请谅解')
      //   return;
      // } 
      this.searchForm.startPayTime = this.searchForm.date[0]
      this.searchForm.endPayTime = this.searchForm.date[1]
      statementDTO.exportFormulaLog(this.searchForm, { name: '配方日志'}).then(res => {
      })
    }, 1000, true),

  },
}
</script>
<style lang="less" scoped>
.charge-warp {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;

  .el-form-item {
    margin-bottom: 0;
  }

  .table-warp {
    margin-top: 16px;
    flex: 1;

    /deep/.el-table {
      border-color: #DDDDDD;
    }

    /deep/.pagination-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 0;

      .total-tips {
        color: #667182;
        font-size: 14px;
      }
    }
  }
}
</style>